<template>
  <div class="programs">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('programs.hero.eyebrow') }}</span>
        <h1>{{ $t('programs.hero.title') }}</h1>
        <p>{{ $t('programs.hero.subtitle') }}</p>
      </div>
    </section>

    <section class="section">
      <div class="container programs-list">
        <article class="card program-card" v-for="p in programs" :key="p.key">
          <div class="program-head">
            <IconBadge :icon="p.icon" :tone="p.tone" size="lg" />
            <h2>{{ $t(`programs.${p.key}.title`) }}</h2>
          </div>
          <p class="program-intro">{{ $t(`programs.${p.key}.intro`) }}</p>
          <ul class="goals">
            <li><IconBadge icon="check" size="sm" tone="green" /> {{ $t(`programs.${p.key}.goal1`) }}</li>
            <li><IconBadge icon="check" size="sm" tone="green" /> {{ $t(`programs.${p.key}.goal2`) }}</li>
            <li><IconBadge icon="check" size="sm" tone="green" /> {{ $t(`programs.${p.key}.goal3`) }}</li>
          </ul>
        </article>
      </div>
    </section>

    <section class="cta-band">
      <div class="container cta-inner">
        <h2>{{ $t('programs.cta.title') }}</h2>
        <p>{{ $t('programs.cta.text') }}</p>
        <div class="hero-actions">
          <router-link to="/donate" class="btn btn-accent">{{ $t('nav.donate') }}</router-link>
          <router-link to="/contact" class="btn btn-outline">{{ $t('programs.cta.volunteer') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IconBadge from '@/components/IconBadge.vue';

export default {
  name: 'OurPrograms',
  components: { IconBadge },
  data() {
    return {
      programs: [
        { key: 'women', icon: 'users', tone: 'rose' },
        { key: 'animals', icon: 'paw', tone: 'amber' },
        { key: 'environment', icon: 'tree', tone: 'green' },
        { key: 'clean', icon: 'droplet', tone: 'navy' },
      ],
    };
  },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0; }

.programs-list { display: flex; flex-direction: column; gap: 24px; }
.program-card { display: flex; flex-direction: column; gap: 16px; }
.program-head { display: flex; align-items: center; gap: 18px; }
.program-head h2 { color: var(--charcoal); font-size: 1.25rem; }
.program-intro { color: var(--muted); margin: 0; }
.goals { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 12px 20px; }
.goals li { display: flex; align-items: center; gap: 10px; font-size: 0.93rem; }

.cta-band { background: var(--charcoal); color: #fff; text-align: center; padding: 60px 0; }
.cta-inner p { margin: 10px 0 26px; color: rgba(255,255,255,0.92); }
.hero-actions { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; }
.cta-band .btn-outline { border-color: rgba(255,255,255,0.8); color: #fff; }
</style>
